import { render } from "./SectionDivider.vue?vue&type=template&id=6ae2eb3e"
import script from "./SectionDivider.vue?vue&type=script&lang=js"
export * from "./SectionDivider.vue?vue&type=script&lang=js"

import "./SectionDivider.vue?vue&type=style&index=0&id=6ae2eb3e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__